import React from "react";
import { ShareEmailEntry, TeamEmailEntry } from "./entities";
import { ResourceType, Permission, EntityType } from "./entities";
import { UserModelRole } from "target_wasm";
import { AccessItem } from "./AccessItem";
import { PermissionControl } from "./PermissionControl";
interface EmailItemProps {
  item: ShareEmailEntry | TeamEmailEntry;
  index: number;
  isShareMode: boolean;
  isCurrentUser?: boolean;
  resourceType?: ResourceType;
  updateEmailSettings?: (
    email: string,
    field: string,
    value: string | number,
  ) => void;
  onAccessLevelChange?: (email: string, accessLevel: string) => void;
  onRemove?: (email: string) => void;
  disabled?: boolean;
  canRevokeAccess: boolean;
}

export const EmailItem: React.FC<EmailItemProps> = (props) => {
  const isModelResource = props.resourceType === ResourceType.Model;

  const getCurrentAccess = (): string => {
    if (!props.isShareMode) {
      return (props.item as TeamEmailEntry).accessLevel;
    }

    const shareItem = props.item as ShareEmailEntry;

    if (isModelResource) {
      const accessLevel = shareItem.accessLevel as UserModelRole | string;

      if (typeof accessLevel === "number") {
        return UserModelRole[accessLevel] ?? String(accessLevel);
      }

      return accessLevel;
    }

    return shareItem.accessLevel === Permission.CanShare
      ? "Can Share"
      : "Can Import";
  };

  const handleAccessChange = (newAccess: string) => {
    if (props.isShareMode && props.updateEmailSettings && props.resourceType) {
      const shareItem = props.item as ShareEmailEntry;
      if (props.resourceType === ResourceType.Model) {
        props.updateEmailSettings(
          shareItem.email,
          "accessLevel",
          Number(newAccess),
        );
      } else {
        props.updateEmailSettings(shareItem.email, "accessLevel", newAccess);
      }
    } else if (
      !props.isShareMode &&
      props.onAccessLevelChange &&
      !props.isCurrentUser
    ) {
      const teamItem = props.item as TeamEmailEntry;
      props.onAccessLevelChange(teamItem.email, newAccess);
    }
  };

  const handleRemove = () => {
    if (props.onRemove) {
      props.onRemove(props.item.email);
    }
  };

  const canChangeAccess =
    (props.isShareMode && props.updateEmailSettings && props.resourceType) ||
    (!props.isShareMode &&
      props.onAccessLevelChange &&
      !props.isCurrentUser &&
      !props.disabled);

  const canRemove =
    (!props.isShareMode && props.onRemove && !props.isCurrentUser) ||
    (props.isShareMode && props.canRevokeAccess);

  return (
    <AccessItem
      primaryText={props.item.email}
      tooltipText={props.isShareMode ? props.item.email : undefined}
      isCurrentUser={props.isCurrentUser}
      permissionLabel={
        <PermissionControl
          currentAccess={getCurrentAccess()}
          resourceType={props.resourceType || ResourceType.Model}
          isDisabled={!canChangeAccess || props.disabled}
          isUpdating={false}
          isCurrentUser={props.isCurrentUser}
          onAccessChange={canChangeAccess ? handleAccessChange : undefined}
          onRemove={canRemove ? handleRemove : undefined}
          entityType={props.isShareMode ? EntityType.User : EntityType.Team}
        />
      }
      canRevokeAccess={false}
      className="group relative overflow-visible rounded-app hover:bg-list-hover px-2"
    />
  );
};
